import type { Snapshot } from "../types";

// Default state of the audio player
export default {
    isUnloaded: true,
    isLoading: false,
    isReady: false,
    isLooping: false,
    isPlaying: false,
    isStopped: false,
    isPaused: false,
    duration: 0,
    rate: 1,
    volume: 1,
    isMuted: false,
    error: undefined
} as Snapshot;